import { createAsyncThunk } from "@reduxjs/toolkit";

import { axiosInstance as axios } from "../../../../api/axiosInstance";
import { showSnackbar } from "../../../reducers/snackbar/snackbarSlice";

export const getUserInfo = createAsyncThunk(
  "getUserInfo",
  (_, { dispatch, rejectWithValue }) => {
    return axios.get("/api/v1/users/me")
      .then(resp => {
        return resp.data;
      })
      .catch(() => {
        const errorMessage = "There was an error fetching the current user information";

        dispatch(showSnackbar({
          message: errorMessage,
          variant: "error"
        }));

        return rejectWithValue(errorMessage);
      });
  }
);
